module.exports = __webpack_public_path__ + "static/media/Group 28316.49d9d0e8.svg";